import React, { ReactElement } from 'react';
import { isAddressCoordinates } from '../../shared/stringUtils';

import s from './Portfolio.module.scss';

interface ProjectMapProps {
  address: string;
  zip: string;
  state: string;
}

export default function ProjectMap(props: ProjectMapProps): ReactElement {
  const { address, zip, state } = props;
  return (
    <>
      <div className={s.subTitle}>
        {!isAddressCoordinates(address) && `${address}, `}
        {`${zip} ${state}`}
      </div>
      <div className={s.mapWrapper}>
        <iframe
          title="Project Map"
          src={`https://maps.google.at/maps?q=${address}&output=embed`}
          width="100%"
          height="550px"
          frameBorder="0"
          style={{ border: 0 }}
          allowFullScreen
          aria-hidden="false"
        />
      </div>
    </>
  );
}
